import { useEffect, useState } from 'react'
import { ListPageHeader } from '@/components/common/ListPageHeader'
import { useIntegrationSources } from './hooks'
import { SourceListPanel } from './components/SourceListPanel'
import { SourceDetailPanel } from './components/SourceDetailPanel'

export function IntegrationsAdminPage() {
  const sourcesQ = useIntegrationSources()
  const sources = sourcesQ.data ?? []
  const [selectedCode, setSelectedCode] = useState<string | null>(null)

  useEffect(() => {
    if (selectedCode && sources.some(s => s.code === selectedCode)) return
    setSelectedCode(sources[0]?.code ?? null)
  }, [sources, selectedCode])

  const selected = sources.find(s => s.code === selectedCode) ?? null

  return (
    <div className="flex flex-col w-full h-full">
      <ListPageHeader
        title="Integracje"
        subtitle="Każde źródło (pvslides, ACX, Focus...) odbiera webhooki na własny kod, uwierzytelnia się nagłówkiem z sekretu i mapuje pola payloadu na pola encji."
      />
      <div className="flex flex-1 overflow-hidden">
        <SourceListPanel
          sources={sources}
          isLoading={sourcesQ.isLoading}
          selectedCode={selectedCode}
          onSelect={setSelectedCode}
        />
        {selected ? (
          <SourceDetailPanel source={selected} />
        ) : (
          <div className="flex-1 flex items-center justify-center text-sm text-slate-500">
            Wybierz źródło lub dodaj nowe.
          </div>
        )}
      </div>
    </div>
  )
}
